<template>
  <div v-if="resource.geoserver">
    <div class="form-row">
      <div
        class="form-group col-6"
      >
        <label 
          class="required"
          style="margin-top: 1em;"
        >
          {{ $tc('resource.geoserver.workspace.label', 1) }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          :name="`Layer workspace ${usedFor}`"
          :rules="'required'"
        >
          <div
            class="control"
            :class="classes"
          >
            <Multiselect
              v-model="form.workspace"
              style="margin-top: 0.5em;"
              class="search-usergroups"
              :options="workspaces"
              :allow-empty="true"
              track-by="name"
              label="name"
              :reset-after="false"
              select-label=""
              selected-label=""
              deselect-label=""
              :searchable="true"
              :placeholder="$t('resource.geoserver.workspace.placeholder')"
              :loading="workspacesLoading"
              :disabled="workspacesLoading"
              :clear-on-select="false"
              @select="selectWorkspace"
            />
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
      <div
        v-if="resource.geoserver.workspace"
        class="form-group col-6 layers-layergroups"
      >
        <b-form-group>
          <b-form-radio-group
            id="btn-radios"
            v-model="layersORlayergroups"
            :options="[
              { text: $tc('resource.geoserver.layer.label', 2), value: 'restlayers' },
              { text: $tc('resource.geoserver.layergroup.label', 2), value: 'restlayergroups' }
            ]"
            button-variant="outline-primary"
            name="radio-btn-outline"
            buttons
          />
        </b-form-group>
      </div>
    </div>
    <div
      v-if="resource.geoserver.workspace"
      class="form-row"
    >
      <div
        :class="{ disabled: layersORlayergroups !== 'restlayers'}"
        class="form-group col-6"
      >
        <label 
          :class="{ required: layersORlayergroups === 'restlayers'}"
          style="margin-top: 1em;"
        >
          {{ $tc('resource.geoserver.layer.label', 1) }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          :name="`Layer layer ${usedFor}`"
          :rules="`${layersORlayergroups === 'layers' ? 'required' : ''}`"
        >
          <div
            class="control"
            :class="classes"
          >
            <Multiselect
              v-model="form.layername"
              style="margin-top: 0.5em;"
              class="search-usergroups"
              :options="layers"
              :allow-empty="true"
              track-by="name"
              label="name"
              :reset-after="false"
              select-label=""
              selected-label=""
              deselect-label=""
              :searchable="true"
              :placeholder="$t('resource.geoserver.layer.placeholder')"
              :loading="layersLoading"
              :disabled="layersLoading"
              :clear-on-select="false"
              @select="selectLayer"
            />
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
      <div
        :class="{ disabled: layersORlayergroups !== 'restlayergroups'}"
        class="form-group col-6"
      >
        <label 
          :class="{ required: layersORlayergroups === 'restlayergroups'}"
          style="margin-top: 1em;"
        >
          {{ $tc('resource.geoserver.layergroup.label', 1) }}
        </label>
        <ValidationProvider
          v-slot="{ classes, errors }"
          :name="`Layer layergroup ${usedFor}`"
          :rules="`${layersORlayergroups === 'restlayergroups' ? 'required' : ''}`"
        >
          <div
            class="control"
            :class="classes"
          >
            <Multiselect
              v-model="form.layergroup"
              style="margin-top: 0.5em;"
              class="search-usergroups"
              :options="layergroups"
              :allow-empty="true"
              track-by="name"
              label="name"
              :reset-after="false"
              select-label=""
              selected-label=""
              deselect-label=""
              :searchable="true"
              :placeholder="$t('resource.geoserver.layergroup.placeholder')"
              :loading="layergroupsLoading"
              :disabled="layergroupsLoading"
              :clear-on-select="false"
              @select="selectLayergroup"
            />
            <span class="form-errors">{{ errors[0] }}</span>
          </div>
        </ValidationProvider>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState,  mapActions } from 'vuex';

import Multiselect from 'vue-multiselect';
import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
import geoserverAPI from '@/api/modules/resource/geoserver.api.js';
extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'GeoserverCreator',

  components: {
    Multiselect,
    ValidationProvider
  },

  props: {
    required: {
      type: Boolean,
      default: true
    },
    resource: {
      type: Object,
      default: () => ({})
    },
    usedFor: {
      type: String,
      default: 'resource'
    },
    trigger: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      workspacesLoading: false,
      layersLoading: false,
      layergroupsLoading: false,
      layersORlayergroups: 'restlayers',
      layers:[],
      layergroups:[],
      form: {
        type: 'geoserver',
        layername:null,
        layergroup:null,
        layerType: null,
        workspace:null,
      }
    };
  },

  computed: {
    ...mapState('resources/geoserver', [
      'workspaces',
    ])
  },

  watch: {
    trigger(newValue) {
      if (newValue && this.workspaces.length === 0) {
        this.workspacesLoading = true;
        this.GET_WORKSPACES()
          .then(() => {
            this.workspacesLoading = false;
          })
          .catch(() => {
            this.workspacesLoading = false;
          });
      }
    },
    form: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue.workspace.name !== oldValue.workspace.name) {
          this.form.layer = null;
          this.form.layergroup = null;
        }       
      }
    },
    'resource.geoserver.workspace': {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.name && oldValue && oldValue.name && newValue.name !== oldValue.name) {
          this.resource.geoserver.layer = null;
          this.resource.geoserver.layergroup = null;
        }
      }
    },
    layersORlayergroups(newValue) {
      if (newValue === 'restlayers') {
        this.resource.geoserver.layergroup = null;
      }
      if (newValue === 'restlayergroups') {
        this.resource.geoserver.layer = null;
      }
    }
  },

  mounted() {
    this.resource.type='geoserver';
    this.$set(this.resource, 'geoserver', { workspace:'',layer:'' });
    if (!this.workspaces || (this.workspaces && this.workspaces.length === 0)) {
      this.workspacesLoading = true;
      this.GET_WORKSPACES()
        .then(() => {
          this.workspacesLoading = false;
        })
        .catch(() => {
          this.workspacesLoading = false;
        });
    }
  },

  methods: {

    ...mapActions('resources/geoserver', [
      'GET_WORKSPACES',
      'GET_LAYERS',
      'GET_LAYERGROUPS'
    ]),
    selectWorkspace(e) {
      this.resource.geoserver.workspace=e.name;
      
      this.layersLoading = true;
      this.layergroupsLoading = true;
      geoserverAPI.getWorkspaceLayers(e.name).then((payload)=>{
        this.layersLoading = false;
        if (payload.layers && payload.layers.layer) {
          this.layers = payload.layers.layer.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          this.layers = [];
        }
      });
      geoserverAPI.getWorkspaceLayergroups(e.name).then((payload)=>{
        this.layersLoading = false;
        if (payload.layerGroups && payload.layerGroups.layerGroup) {
          this.layergroups = payload.layerGroups.layerGroup.sort((a, b) => a.name.localeCompare(b.name));
        } else {
          this.layergroups = [];
        }

      });

    },
    selectLayer(e) {
      this.form.layerType = this.layersORlayergroups;
      this.resource.geoserver.layername=e.name;
    },
    selectLayergroup(e) {
      this.form.layerType = this.layersORlayergroups;
      this.resource.geoserver.layername=e.name;
    },
  }
};
</script>

<style lang="less" scoped>
.layers-layergroups {
  display: flex;
  align-items: flex-end;
  justify-content: center;
  fieldset {
    margin-bottom: 2px;
  }
}
</style>
